import SuperHeaders from '@mjackson/headers';

type CookieField<T> = {
  name: string;
  parse?: (raw: string) => T | undefined;
};

type CookieSchema<T> = { [K in keyof T]-?: CookieField<NonNullable<T[K]>> };

export function readCookies<T extends Record<string, unknown>>(headers: Headers, schema: CookieSchema<T>): T {
  const { cookie } = new SuperHeaders(headers);
  const out = {} as T;
  for (const key in schema) {
    const { name, parse } = schema[key];
    const raw = cookie.get(name);
    if (raw === undefined) continue;
    const value = parse ? parse(raw) : (raw as NonNullable<T[typeof key]>);
    if (value !== undefined) out[key] = value as T[typeof key];
  }
  return out;
}
